(function () {
    'use strict';

    angular
        .module('app.paymentTransactions')
        .run(appRun);

    appRun.$inject = ['routerHelper', 'opsIncludeVersion'];
    /* @ngInject */
    function appRun(routerHelper, opsIncludeVersion) {
        routerHelper.configureStates(getStates(opsIncludeVersion));
    }

    function getStates(opsIncludeVersion) {
        return [
              {
                state: 'paymenttransactions',
                config: {
                      abstract: true,
                      url: '/paymenttransactions',
                      template: '<ui-view/>',
                      settings: {
                          authMode: 1
                          
                      }
                  }
              },
            {
                state: 'paymenttransactions.list',
                config: {
                    url: '/list',
                    templateUrl: 'app/paymenttransactions/list.html?v=' + opsIncludeVersion,
                    controller: 'PaymentTransactionsListController',
                    controllerAs: 'vm',
                    title: 'Payment Transactions',
                    settings: {
                        nav: 700,
                        content: '<i class="fa fa-money"></i> <span class="leftNavText">Transactions</span>',
                        authMode: 1,
                        requireBillingDepartments: true,
                        mobileButton: true
                    },
                    resolve: {
                        authenticationRequired: ['userService', function (userService) {
                            userService.isAuthenticatedThrowError();
                            if (!userService.isCollegeNetApi()) {
                                if (userService.billingDepartmentIds().length === 0) {
                                    throw { name: "NoBillingDepartments" };
                                }
                            }
                            else {
                                if (userService.numberOfPaymentTemplates() == 0) {
                                    throw {name: "NoPaymnetTemplates"}
                                }
                            }
                            
                        }]
                    }
                }
            }
        ];
    }
})();
